// Yandex.Metrika goal tracking wrapper
const YM_ID = 108495179

const fired = new Set()

const reachGoal = (goal, params) => {
  if (typeof window.ym !== 'function') return
  window.ym(YM_ID, 'reachGoal', goal, params)
}

const reachGoalOnce = (goal, params) => {
  if (fired.has(goal)) return
  fired.add(goal)
  reachGoal(goal, params)
}

export const trackLeadFormSubmit = (params) => reachGoal('lead_form_submit', params)
export const trackCalcOpen = () => reachGoalOnce('calc_open')
export const trackCalcStart = () => reachGoalOnce('calc_start')
export const trackCalcResult = () => reachGoalOnce('calc_result')
export const trackCalcSubmit = (params) => reachGoal('calc_submit', params)
export const trackPhoneClick = (params) => reachGoal('phone_click', params)
export const trackWhatsappClick = (params) => reachGoal('whatsapp_click', params)
